import React, { useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import {
  Card,
  CardBody,
  Col,
  Container,
  Label,
  Row,
  Form,
  Button,
  CardTitle,
  Input,
  FormFeedback,
  UncontrolledTooltip,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";

// Redux
import { connect, useDispatch } from "react-redux";
import { withRouter, useHistory, Link, useParams } from "react-router-dom";

// Backend
import { getRateDetail } from "connection/backend";

// actions
import { rateUpdate } from "store/actions";

//Import Breadcrumb
import Breadcrumb from "components/Common/Breadcrumb";
import Loader from "components/Common/Loader";

// actions
import { rateCreate } from "store/actions";

const RateUpdate = (props) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();

  const redirect = () => {
    history.push("/rates");
  };

  const getData = async (id) => {
    const response = await getRateDetail(id);
    const data = response.data;
    setFormData({
      rate_value: data.rate_value,
    });
  };

  useEffect(() => {
    getData(id);
  }, []);

  const [formData, setFormData] = useState({ rate_value: "" });
  const { rate_value } = formData;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    dispatch(rateUpdate(id, formData));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Carnesvilla | Tarifas </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={"Carnesvilla"} breadcrumbItem={"Tarifas"} />
          {props.loading ? (
            <Loader />
          ) : (
            <div className="d-flex justify-content-center">
              {props.rateUpdated.id ? (
                <SweetAlert
                  title="¡Hecho!"
                  success
                  showConfirm={true}
                  onConfirm={() => {
                    redirect();
                  }}
                >
                  La tarifa se ha actualizado correctamente.
                </SweetAlert>
              ) : null}
              <Card
                style={{
                  width: "70rem",
                }}
              >
                <CardTitle className="ps-3 pt-3">
                  <h2 className="mb-3 font-size-20">Actualizar tarifa</h2>
                </CardTitle>
                <CardBody>
                  <Form onSubmit={onSubmit}>
                    <Row className="justify-content-md-center">
                      <Col lg={5}>
                        <p>Valor</p>
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center">
                      <Col lg={5}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bx-dollar bx-sm" />
                          </span>
                          <div className="form-floating">
                            <Input
                              type="number"
                              className="form-control"
                              placeholder="Tarifa"
                              name="rate_value"
                              id="rate_value"
                              value={rate_value}
                              onChange={onChange}
                              {...(props.error && {
                                ...(props.error.rate_value
                                  ? { invalid: true }
                                  : { valid: true }),
                              })}
                              required
                            />
                            <FormFeedback tooltip>
                              {props.error.rate_value}
                            </FormFeedback>
                            <Label for="rate_value">Tarifa</Label>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center mt-4 ms-5">
                      <Col lg={3}>
                        <Link className="btn btn-danger me-4" to="/rates">
                          Cancelar
                        </Link>

                        <Button color="success" type="submit">
                          Actualizar
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { error, loading, rateUpdated } = state.Rate;
  return { error, loading, rateUpdated };
};

export default withRouter(connect(mapStateToProps)(RateUpdate));
